
import _ from "lodash"
import { Base64 } from "js-base64"
import { Drawer, MessageBox, Dialog, Divider } from "element-ui"
import editRecipient from "../drawer/editRecipient.vue"
import couponSelect from "../drawer/couponSelect.vue"
import collectOrder from "../drawer/collectOrder.vue"
import deliveryMethod from "../drawer/deliveryMethod.vue"
import { getCartDetailV2, modifyCartV2, getCouponBillV2 } from "../../api/cart"
import redeemItems from "./redeemItems.vue"
import discountReceived from "./discountReceived.vue"
import bestOffer from "./bestOffer.vue"
import disabledGoods from "./disabledGoods.vue"
import saveMoreOffers from "./saveMoreOffers.vue"
import freeGifts from "./freeGifts.vue"
import wareCard from "./wareCard.vue"
import cartEmpty from "./cartEmpty.vue"
import {
  isChecked,
  soldOut,
  fen2Yuan,
  getNumber,
  getSmallNumber,
  showMessage,
  getRangeStore,
  getRangeSlaveStoreList,
  getItemGroup,
  getWareItems,
  getUniqWares,
  filterShipmentList,
  buildDeliveryTabList,
  getMatchedCheckedCount
} from "./js/common.js"
import linkYuu from "@/components/linkYuu/linkYuu.vue"
// import invalidProducts from "./invalidProducts.vue"
import tooltip from "@/components/tooltip.vue"
import {
  tooltipCustomStyle,
  openNoAddressPop,
  getDisplayAddress,
  noAddressCheck,
  getDeliveryMethod,
  cartResetStoreInfo,
  showGlobalMessage,
  getCurrentAddress,
  customSkuKey
} from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"
import { trackViewCart, trackBeginCheckout, trackAddShippingInfo, handleChangeCartNumber } from "@/utils/track"
import storage from "@/utils/storage"
import editAddress from "@/components/drawer/editAddress.vue"
import myAddress from "@/components/cart/myAddress.vue"
import { deleteAddress } from "@/api/address"
import productSku from "@/components/drawer/productSku.vue"
import productCustomSku from "@/components/drawer/productCustomSku.vue"
// import { promotionData, checkoutData } from "@/components/cart/js/cart.js"
export default {
  name: "CartDetail",
  components: {
    [Drawer.name]: Drawer,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    redeemItems,
    productSku,
    discountReceived,
    bestOffer,
    saveMoreOffers,
    freeGifts,
    wareCard,
    cartEmpty,
    disabledGoods,
    // invalidProducts,
    editRecipient,
    couponSelect,
    collectOrder,
    deliveryMethod,
    tooltip,
    linkYuu,
    editAddress,
    myAddress,
    productCustomSku
  },
  data() {
    return {
      skuVisible: false,
      customSkuVisible: false,
      configs: {},
      customContentConfig: null,
      blacklistProducts: [], // 黑名单商品
      deleteAddressItem: {},
      deleteAddressVisible: false,
      selectedButton: null, // 当前选中的按钮
      deliveryWares: [],
      pickUpWares: [],
      addAddressVisible: false,
      defaultAddress: {},
      shipmentType: 1,
      addressList: [],
      addressVisible: false,
      splitNotSellProductTip: "",
      isSelectedAll: false,
      isEdit: false, // 不可选商品点击切换
      goodsList: [],
      drawer: false, // 控制抽屉显示
      deliveryMethodValue: "clickCollect",
      lang: "",
      loading: true,
      msgContent: {
        title: this.$t("cart.removeTitle"),
        message: this.$t("cart.removeMessage"),
        cancelText: this.$t("cart.cancel"),
        confirmText: this.$t("cart.remove")
      },
      giftMsgContent: {
        title: this.$t("cart.reminder"),
        message: this.$t("cart.giftMessage"),
        cancelText: this.$t("cart.no"),
        confirmText: this.$t("cart.yesContinue")
      },
      loadingInstance: null,
      data: {},
      store: {},
      list: [],
      slaveStoreList: [], // 从门店信息
      invalidList: [],
      invalidCount: 0,
      deliveryOnlyCount: 0,
      userInfo: {},
      recipientVisible: false,
      couponVisible: false,
      checkedCoupons: [],
      validCoupons: [],
      invalidCoupons: [],
      ruleTitle: "",
      ruleContent: "",
      billInfo: {},
      consignId: "",
      isQuota: false, // 是否限购
      isBillError: false, // 结算接口是否异常
      collectOrderItem: {},
      collectOrderCartList: [],
      deliveryMethodVisible: false,
      // deliveryMethodOptions: [
      //   {
      //     label: this.$t("deliveryMethod.homeDelivery"),
      //     value: "homeDelivery",
      //     defaultIcon: "carGray",
      //     activeIcon: "car"
      //   },
      //   {
      //     label: this.$t("deliveryMethod.clickCollect"),
      //     value: "clickCollect",
      //     defaultIcon: "cartClickCollectGray",
      //     activeIcon: "cartClickCollect"
      //   }
      // ],
      checkoutParams: {},
      deliveryStyle: {},
      selectedDeliveryId: null,
      deliveryMethodList: [
        // 配送方式初始化显示
        { name: "cart_delivery", class: "icon-delivery", icon: "deliveryCarRight", id: 1, shipmentType: 1 },
        { name: "cart_pick_up", class: "icon-delivery", icon: "pickup", id: 2, shipmentType: 2 }
      ],
      expandOfflineMethodList: [
        // offline配送方式初始化显示
        { name: "cart_delivery", class: "icon-delivery", icon: "deliveryCarRight", id: 3, shipmentType: 1 },
        { name: "cart_pick_up", class: "icon-delivery", icon: "pickup", id: 4, shipmentType: 2 }
      ],
      selectedOfflinePaymentFlag: 0 // 默认为线上支付
    }
  },

  computed: {
    // 动态计算是否需呀全选
    selectAll() {
      const allChecked = this.goodsList.every(item => item.checked)
      return allChecked
    },
    isSelectGoods() {
      const isChecked = this.goodsList.some(item => item.checked)
      return isChecked
    },
    // 显示可以选择的区域
    showOptionalArea() {
      return this.loading || (this.list && this.list.length)
    },

    validItems() {
      const activeTagList = filterShipmentList(this.list, this.selectedDeliveryId, this.shipmentType)
      return activeTagList?.filter(item => !this.soldOut(item))
    },
    validSelectAll() {
      if (!this.validItems || !this.validItems.length) return false
      return true
    },
    isAllSelected() {
      return this.validSelectAll && this.validItems.every(item => this.isChecked(item))
    },
    selectedItems() {
      const activeTagList = filterShipmentList(this.list, this.selectedDeliveryId, this.shipmentType)
      return activeTagList?.filter(item => this.isChecked(item) && !this.soldOut(item))
    },
    hasSelection() {
      return this.selectedItems.length > 0
    },
    // 是否有从门店
    slaveStore() {
      return this.slaveStoreList.length > 0
    },
    recipientInfo() {
      return {
        name: this.userInfo.userName || this.userInfo.name || "",
        num: this.userInfo.phone || "",
        code: this.userInfo.areaCode || ""
      }
    },
    checkedCouponCodes() {
      return this.checkedCoupons.map(item => item.couponCode)
    },
    checkedCouponLen() {
      return (this.checkedCoupons && this.checkedCoupons.length) || 0
    },
    validCouponLen() {
      return (this.validCoupons && this.validCoupons.length) || 0
    },
    billText() {
      const packagingFee = this.billInfo.packaging
      const handlingFee = this.billInfo.baseServiceFee
      if (handlingFee > 0 && packagingFee > 0) {
        return this.$t("cart.handlingAndPackagingFee", {
          handlingFee: this.fen2Yuan(handlingFee),
          packagingFee: this.fen2Yuan(packagingFee)
        })
      } else if (handlingFee > 0 && packagingFee <= 0) {
        return this.$t("cart.onlyHandlingFee", { handlingFee: this.fen2Yuan(handlingFee) })
      } else if (handlingFee <= 0 && packagingFee > 0) {
        return this.$t("cart.onlyPackagingFee", { packagingFee: this.fen2Yuan(packagingFee) })
      }
      return ""
    },
    totalPrice() {
      // 无地址或结算异常用购物车接口，反之用结算接口
      return this.noAddressCheck() || this.isBillError ? this.store.discountPrice : this.billInfo.subtotalPrice
    },
    pickupExpenseResponse() {
      return this.store.pickupExpenseResponse || {}
    }
  },
  // watch: {
  //   // 监听 goodsList 的变化，当 goodsList 变化时，根据 itemsLength 自动更新 drawer 状态
  //   goodsList(newVal, oldVal) {
  //     // 当 goodsList 发生变化时，根据新的 itemsLength 更新 drawer 的状态
  //     this.drawer = this.itemsLength > 0
  //   }
  // },
  async mounted() {
    this.$bus.$off("add-cart-success", this.handleAddCartSuccess)
    this.$bus.$on("add-cart-success", this.handleAddCartSuccess)
    this.lang = getLanguage()

    this.deliveryMethodValue = getDeliveryMethod()
    await this.init()
    this.trackCartsList()
    this.listenAddressChange()

    // if (this.noAddressCheck()) {
    //   openNoAddressPop()
    // }

    const goodsList = this.preOrderShipmentTypeChange(2, this.shipmentType, this.store)
    if (this.shipmentType === 1) {
      this.deliveryWares = goodsList
    } else {
      this.pickUpWares = goodsList
    }
  },
  beforeDestroy() {
    this.$bus.$off("add-cart-success", this.handleAddCartSuccess)
    document.removeEventListener("addressChanged", this.trackAddressChange)
  },
  methods: {
    noAddressCheck,
    getDisplayAddress,
    getRangeStore,
    getRangeSlaveStoreList,
    getItemGroup,
    getWareItems,
    getUniqWares,
    cancel() {
      this.selectedButton = "discard"
      this.deleteAddressVisible = false
    },
    async confirmRmove() {
      this.selectedButton = "continue"
      try {
        const { code, data } = await deleteAddress({ param: JSON.stringify({ id: this.deleteAddressItem.id }) })
        if (code !== "0000") {
          this.$message({
            message: data?.msg || "delete fail",
            type: "warning"
          })
          return
        }
        this.$message({
          message: this.$t("address.addressRemoved"),
          type: "success"
        })
        // 地址删除成功之后刷新地址
        this.getMemberInfo(true)
        // 初始化接口会请求优惠券
        await this.init(false)
        this.deleteAddressVisible = false
      } catch (error) {
        console.log("error:", error)
      }
    },
    // 删除地址 selectedButton = 'continue'
    remove(item) {
      this.deleteAddressVisible = true
      this.deleteAddressItem = item
    },
    preOrderShipmentTypeChange(type, deliveryType, stores) {
      // preOrder订单的履约方式deliveryType * 1:配送  * 2:自提
      // 组件复用，此改动影响最小
      const getWareItemslist = getWareItems(type, stores)

      const wareItemslist = filterShipmentList(getWareItemslist, this.selectedDeliveryId, deliveryType)
      return wareItemslist
    },
    selectedAll() {
      this.isSelectedAll = !this.selectAll
      this.goodsList.map(val => {
        const goodsItem = val
        goodsItem.checked = this.isSelectedAll
        return goodsItem
      })
    },
    // 删除所有选中的商品
    async deleteAllGoods() {
      // 更新
      const goodsArr = this.goodsList.filter(value => value.checked)
      for (const item of goodsArr) {
        const oldCount = item.count
        try {
          item.beforeCount = item.count // 记录之前的 count
          item.count = 0 // 删除商品，count 为 0
          const { data: res } = await modifyCartV2(this.getParams([item]), 3)
          await this.setData(res)
        } catch (error) {
          console.log(error)
          item.count = oldCount // 回滚 count
        }
      }
      // 全部选中的情况下，如果所有商品都被删除
      if (this.selectAll) {
        this.drawer = false
        this.isEdit = false
      }
      this.init(false)
    },
    // 当商品数量为0的时候，删除当前的商品
    async deleteCurrent(value, item) {
      if (value <= 0) {
        this.goodsList = this.goodsList.filter(val => item.uuid !== val.uuid)
      }
      const oldChecked = item.checked
      item.checked = 0
      const oldCount = item.count
      item.beforeCount = item.count // 记录之前的count
      item.count = value
      console.log("item.count==>", item.count)
      try {
        const { data: res } = await modifyCartV2(this.getParams([item]), 3)
        await this.setData(res)
        console.log("handleNumChange", value, item.count)
        handleChangeCartNumber(value, oldCount, item)
      } catch (error) {
        console.log(error)
        item.checked = oldChecked
        item.count = oldCount
      }

      // 当商品数量为0的时候，切所有商品不存在，则关闭弹窗
      if (!this.goodsList.length) {
        this.drawer = false
      }
    },
    // 单独选中当前的商品
    // checkCurrentGoods($event) {
    //   this.goodsList.map(val => {
    //     if (val.uuid === $event.uuid) {
    //       const goodsItem = val
    //       goodsItem.checked = !goodsItem.checked
    //       return goodsItem
    //     } else {
    //       return val
    //     }
    //   })
    // },
    // 选择不可购买的商品事件
    selectGoodsEdit() {
      this.isEdit = !this.isEdit
    },
    // 点击抽屉事件
    drawerChange() {
      this.drawer = true
      console.log(this.drawer, 111)
    },
    // 关闭抽屉
    closeDrawer() {
      this.drawer = false
      this.isEdit = false
    },
    getUnitItem(item) {
      const wareList = item.wareList || []
      const result = wareList[0] || {}
      result.beforeCount = result.count
      return item
    },
    getDisplayStore() {
      let curSelStore = {}
      if (process.client) {
        curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
      }
      return curSelStore
    },
    getFeeMsgContent(bill) {
      const { billItemVOList = [], remarkList = [] } = bill
      if (billItemVOList && billItemVOList.length) {
        const result = billItemVOList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
            <span>${item.name}</span>
            <span>${item.positive ? "" : "-"}$${this.fen2Yuan(item.value)}</span></div>`
        )

        return result
      }

      return remarkList || []
    },
    setCollectOrderCartList() {
      // 根据skuId去重并累加count
      const tempObj = {}
      _.cloneDeep(this.list).forEach(item => {
        const skuId = item.skuId
        if (!(skuId in tempObj)) {
          tempObj[skuId] = item
        } else {
          tempObj[skuId].count += item.count
        }
      })
      this.collectOrderCartList = Object.values(tempObj).map(item => ({
        sku: item.skuId,
        skuId: item.skuId,
        count: item.count,
        stock: item.remainingStock
      }))
    },
    handleOpenCollect(val) {
      let proActUrl = {}
      try {
        proActUrl = JSON.parse(val.promotionDisplay.proActUrl)
      } catch (error) {
        console.log(error)
      }
      this.setCollectOrderCartList()
      this.$refs.collectOrder.open({
        title: proActUrl.mTitle,
        promotionId: val.promotionId,
        storeId: proActUrl.mStoreId,
        bestOffer: false,
        shipmentType: this.shipmentType
      })
    },
    handleOpenBestOffer(val = {}, type, skuId) {
      let promotionId
      let proActUrl = {}

      // 单品里面未凑成bestoffer的促销
      if (type === "unit") {
        try {
          proActUrl = JSON.parse(val.proActUrl)
          promotionId = proActUrl.mValue
        } catch (error) {
          console.log(error)
        }
      } else {
        promotionId = val.promotionId
        if (val.promotionDisplay && val.promotionDisplay.proActUrl) {
          try {
            proActUrl = JSON.parse(val.promotionDisplay.proActUrl)
          } catch (error) {
            console.log(error)
          }
        }
      }

      this.setCollectOrderCartList()
      this.$refs.collectOrder.open({
        skuId,
        promotionId,
        storeId: proActUrl.mStoreId,
        title: proActUrl.mTitle,
        bestOffer: true
      })
    },
    getItemGroupName(type, store) {
      const result = this.getItemGroup(type, store)
      return result.itemGroupName || ""
    },
    getSaveMoreOrReceivedItems(type, store) {
      const result = this.getItemGroup(type, store)
      let promotionList = []
      if (type === 1 && Array.isArray(result)) {
        // 促销的单独逻辑
        result.itemList.map(val =>
          val.promotionList.forEach(ele => {
            if (val.preOrderShipmentType === this.shipmentType) {
              promotionList.push({
                ...ele,
                preOrderShipmentType: val.preOrderShipmentType
              })
            }
          })
        )
      } else {
        ;(result.itemList || []).forEach(item => {
          promotionList.push(...(item.promotionList || []))
        })

        promotionList = promotionList.map(val => {
          return {
            ...val,
            preOrderShipmentType: result.preOrderShipmentType
          }
        })
      }

      return promotionList
    },
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    afterAddressChanged() {
      // 地址切换显示toast
      const isCartAddressChanged = localStorage.getItem("isCartAddressChanged")
        ? JSON.parse(localStorage.getItem("isCartAddressChanged"))
        : false
      if (isCartAddressChanged) {
        localStorage.removeItem("isCartAddressChanged")
        showMessage(this.$t("cart.addressChangedTips"))
      }
    },
    handleAddCartSuccess() {
      this.$nextTick(() => {
        this.init(false)
      })
    },
    async init(isGetMemberInfo = true) {
      this.loading = true

      try {
        // 地址函数执行之后，优惠券接口根据地址信息返回
        if (isGetMemberInfo) {
          await this.getMemberInfo()
        }
        const params = {
          isCollage: false,
          sort: 0,
          simple: 1,
          addressId: this.defaultAddress.id
        }
        const { data: res } = await getCartDetailV2({ param: JSON.stringify(params) }, 3)

        await this.setData(res)
        this.afterAddressChanged()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    addressInfo(res) {
      if (res.address.length) {
        // 如果默认地址存在
        const addressObject = res.address.filter(item => item.priority && item)[0]
        const notAddressObject = res.address.filter(item => !item.priority && item)[0]
        if (addressObject) {
          this.defaultAddress = {
            ...addressObject,
            areaCode: res.areaCode,
            custId: res.custId,
            name: res.name,
            phone: res.phone,
            userId: res.userId,
            userName: res.userName,
            yuuId: res.yuuId
          }
          this.addressList = res.address
        } else {
          this.addressList = res.address
          this.addressList[0].priority = "Default"
          this.defaultAddress = {
            ...notAddressObject,
            areaCode: res.areaCode,
            custId: res.custId,
            name: res.name,
            phone: res.phone,
            userId: res.userId,
            userName: res.userName,
            yuuId: res.yuuId
          }
        }
      } else {
        // 个人信息的地址，与收货地址不同
        this.defaultAddress = res
        this.addressList = []
      }
    },

    async getMemberInfo(flag = false) {
      try {
        let address = {}
        if (flag) {
          address = await this.$store.dispatch("getLoginInfo")
        } else {
          // 个人信息的地址，与收货地址不同
          address = storage.get("accountInfo", { useBase64: true }) || {}
        }
        // 从个人信息缓存里获取
        this.addressInfo(address)
      } catch (error) {
        console.log(error)
      }
    },
    getStoreInfo(data = {}) {
      return {
        mappingType: data.storeInfo && data.storeInfo.mappingType,
        storeId: data.storeId,
        venderId: data.venderId
      }
    },
    getCouponBillParams() {
      const rangeStoreList = (this.data.storeGroupList || []).find(item => item.storeGroupType === "Range")
        ?.storeList || [this.store]
      const allStores = _.uniqBy(
        [...rangeStoreList, ...(this.slaveStore ? this.slaveStoreList : [])].map(item => this.getStoreInfo(item)),
        "storeId"
      )
      const checkedStoreIds = _.uniq(this.selectedItems.map(item => item.storeId))
      const checkedStores = allStores.filter(item => checkedStoreIds.includes(item.storeId))
      const checkedMainStore = checkedStores.find(item => rangeStoreList.some(store => store.storeId === item.storeId))

      // 只有主门店
      const onlyMainStore = checkedStores.length === 1 && !!checkedMainStore

      return {
        addSlaveCoupon: !!(this.checkedCoupons && this.checkedCoupons.length),
        storeId: checkedMainStore?.storeId || this.getMasterStoreId(),
        checkedStores,
        tradeMode: !checkedStores.length || onlyMainStore ? "1" : "2"
      }
    },
    getCouponParams() {
      return {
        couponCodeList: this.checkedCouponCodes,
        tradeCouponVOs: this.checkedCoupons.map(item => ({
          couponCode: item.couponCode,
          storeId: item.storeId
        })),
        needHangUp: false
      }
    },
    getCalcCouponParams() {
      const attachParam = { offlinePaymentFlag: this.selectedOfflinePaymentFlag }
      return Object.assign({ needHangUp: true }, this.getAddressParams(), this.getCouponBillParams(), attachParam)
    },
    async getCheckout(isManual = false) {
      // if (this.noAddressCheck() || !this.hasSelection) {
      //   this.billInfo = {}
      //   this.validCoupons = []
      //   this.invalidCoupons = []
      //   this.checkedCoupons = []
      //   if (this.noAddressCheck() && this.shipmentType === 2) {
      //     openNoAddressPop()
      //   }
      //   return
      // }
      try {
        const originParams = isManual ? this.getCouponParams() : { needHangUp: true }

        const clickCollectParams = {}
        // 配送情况下的参数
        if (this.shipmentType === 1) {
          Object.assign(clickCollectParams, {
            longitude: this.defaultAddress.lng,
            latitude: this.defaultAddress.lat,
            address2: this.defaultAddress.address2
          })
        } else {
          const curSelStore = this.getDisplayStore()
          Object.assign(clickCollectParams, {
            longitude: curSelStore.lng,
            latitude: curSelStore.lat,
            address2: encodeURIComponent(curSelStore.address)
          })
        }
        const params = Object.assign(
          this.getAddressParams(),
          this.getCouponBillParams(),
          originParams || {},
          clickCollectParams,
          {
            offlinePaymentFlag: this.selectedOfflinePaymentFlag
          }
        )
        this.checkoutParams = _.cloneDeep(params)
        const { data: res } = await getCouponBillV2({ param: { ...params, shipmentType: this.shipmentType } })
        if (res) {
          this.isBillError = res.code !== "0000"
          this.isQuota = res.code === "51001" // 限购

          if (!this.isBillError) {
            this.consignId = res.consignId || ""
            this.billInfo = res.billInfoV2 || {}

            this.ruleTitle = res.useInstructionsTitle || ""
            this.ruleContent = res.useManual || ""
            this.validCoupons = (res.couponReponse && res.couponReponse.valid) || []
            this.invalidCoupons = (res.couponReponse && res.couponReponse.invalid) || []
            this.checkedCoupons = this.validCoupons.filter(item => !!item.checked)
          } else if (!this.isQuota && (res.result || res.msg)) {
            showMessage(res.result || res.msg)
          }
        } else {
          this.isBillError = true
        }
      } catch (error) {
        console.log(error)
        this.isBillError = true
      }
    },
    async setData(res) {
      this.list = []
      this.data = res || {}
      this.setDeliveryTabList(res?.storeGroupList?.[0] || []) // 设置购物车篮子tab选项

      if (res.storeGroupList.length) {
        const checkedNum = getMatchedCheckedCount(
          res.storeGroupList[0].storeList,
          this.shipmentType,
          this.selectedOfflinePaymentFlag
        )
        if (this.shipmentType === 2) {
          this.data.pickUpCheckedCount = checkedNum
        } else {
          this.data.deliverCheckedCount = checkedNum
        }
      }

      // 根据shipmentType进行分类
      if (this.data.storeGroupList.length && this.data.storeGroupList[0].storeList.length) {
        this.data.storeGroupList[0].storeList[0] = this.data.storeGroupList[0].storeList.filter(
          val => val.preOrderShipmentType === this.shipmentType
        )[0]
      }

      this.store = this.getRangeStore(this.data) // 主门店
      const goodsList = this.preOrderShipmentTypeChange(2, this.shipmentType, this.store)
      if (this.shipmentType === 1) {
        this.deliveryWares = goodsList
      } else {
        this.pickUpWares = goodsList
      }
      this.slaveStoreList = this.getRangeSlaveStoreList(this.data) // 从门店信息
      // 是否调整过赠品或者换购商品, 1: 是, 0: 否
      if (this.data.changedGiftOrTradeFlag == 1) {
        showMessage(this.$t("cart.changedGiftOrTradeMsg"), this.$t("cart.changedGiftOrTradeMinorMsg"))
      }

      const tip = (this.shipmentType === 2 && this.pickupExpenseResponse.minPriceTip) || ""
      const rate = this.shipmentType === 2 && this.store.pickupMinPriceFlag === 1 ? 1 : 0
      this.$bus.$emit("setOnlineStoreTags", {
        tip,
        rate
      })
      this.$bus.$emit("setCartCount", this.data.checkedCount)

      // const bestOfferItems = [...this.getWareItems(2, this.store)]   2025.04.15临时注释
      const bestOfferItems = [...this.getWareItems(2, this.store)]
      this.slaveStoreList.forEach(item => {
        bestOfferItems.push(...this.getWareItems(2, item))
      })

      bestOfferItems.forEach((item, index) => {
        item.wareList.forEach(subItem => {
          // 当刷新购物车时,剩余库存比之前的少,取消勾选并且展示一个提示
          const stock = subItem.remainingStock
          if ((item.itemType === 1 || item.itemType === 3) && stock && subItem.count > stock) {
            subItem.showStockTip = true
            subItem.stockTip = this.$t("cart.stockTips", { stock })
            if (this.isChecked(subItem)) {
              this.toggleWareSelect({ items: [subItem], manualClick: false })
            }
          } else {
            subItem.showStockTip = false
          }
          subItem.index = index
          this.list.push(subItem)
        })
      })

      // 抽屉弹窗
      if (res.storeGroupList.length && res.storeGroupList[0].storeList[0]?.splitNotSellItems) {
        const goodArr = res.storeGroupList[0].storeList.filter(val => val.preOrderShipmentType === this.shipmentType)[0]
          ?.splitNotSellItems
        this.splitNotSellProductTip = res.storeGroupList[0].storeList.filter(
          val => val.preOrderShipmentType === this.shipmentType
        )[0]?.pickupExpenseResponse?.splitNotSellProductTip
        if (Array.isArray(goodArr)) {
          this.goodsList = goodArr.map(e => {
            return {
              uuid: e.wareList[0].uuid,
              ...e.wareList[0]
            }
          })
        } else {
          this.goodsList = []
        }
      } else {
        this.goodsList = []
      }
      this.focusStore()
      // 一期暂时没有invalid模块
      // this.setInvalidList()
      await this.getCheckout()
    },
    getFocusInfo() {
      const headerEl = document.getElementById("top-box")
      const headerHeight = (headerEl && headerEl.clientHeight) || 0

      const cartPageEl = document.getElementById("cart-page-wrapper")
      const computed = cartPageEl ? window.getComputedStyle(cartPageEl) : null

      const CART_MARGIN_TOP = computed && computed["margin-top"] ? parseFloat(computed["margin-top"]) : 0 // 购物车到header的距离
      const cartAndHeaderGap = CART_MARGIN_TOP - headerHeight

      return { cartAndHeaderGap }
    },
    focusStore() {
      this.$nextTick(() => {
        const { focusStoreId } = this.data
        if (!focusStoreId) return

        const slaveStoreEl = document.getElementById(`slave-store-${focusStoreId}`)
        const { cartAndHeaderGap } = this.getFocusInfo()

        // 主门店
        if (this.store.storeId == focusStoreId) {
          const mainStoreEl = document.getElementById("mainStore")
          window.scrollTo({
            top: mainStoreEl.offsetTop + cartAndHeaderGap,
            behavior: "smooth"
          })
        } else if (slaveStoreEl) {
          // 从门店
          window.scrollTo({
            top: slaveStoreEl.offsetTop + cartAndHeaderGap,
            behavior: "smooth"
          })
        }
      })
    },
    focusDeliveryOnly() {
      this.$nextTick(async () => {
        if (this.$refs.invalidProducts) {
          if (!this.$refs.invalidProducts.isShow) {
            this.$refs.invalidProducts.toggleShow && this.$refs.invalidProducts.toggleShow()
          }
        }

        await this.$nextTick()

        const { cartAndHeaderGap } = this.getFocusInfo()
        const deliveryOnlyEl = document.getElementById("category-wrapper-deliveryOnly")
        window.scrollTo({
          top: deliveryOnlyEl.offsetTop + cartAndHeaderGap,
          behavior: "smooth"
        })
      })
    },
    getStoreGroup(type) {
      return (this.data.storeGroupList || []).find(item => item.storeGroupType === type) || {}
    },
    setInvalidList() {
      this.invalidCount = 0
      this.deliveryOnlyCount = 0

      const cloneStore = _.cloneDeep(this.store)
      const deliveryOnlyItems = this.getWareItems(-1, cloneStore)
      this.deliveryOnlyCount = this.getUniqWares(deliveryOnlyItems).length
      const allCategories = [
        {
          type: "deliveryOnly",
          title: this.$t("cart.deliveryOnlyTitle"), // delivery only
          storeList: deliveryOnlyItems.length ? [cloneStore] : []
        },
        {
          type: "rangeNotNearest",
          title: this.$t("cart.rangeNotNearestTitle"),
          storeList: this.getStoreGroup("UnRange").storeList || []
        },
        {
          type: "rangeStandardDelivery",
          title: this.$t("cart.rangeStandardDeliveryTitle"),
          storeList: this.getStoreGroup("PreOrder").storeList || []
        },
        {
          type: "unRangeStoreGroup",
          title: this.$t("cart.unRangeStoreGroupTitle"),
          storeList: this.getStoreGroup("Express").storeList || []
        }
      ]

      this.invalidList = allCategories.filter(item => item.storeList.length)
      const items = []
      this.invalidList.forEach(item => {
        item.storeList.forEach(storeItem => {
          items.push(...this.getWareItems(item.type === "deliveryOnly" ? -1 : 2, storeItem))
          // 从门店
          if (storeItem.slaveStoreList && storeItem.slaveStoreList.length) {
            storeItem.slaveStoreList.forEach(slaveStoreItem => {
              items.push(...this.getWareItems(item.type === "deliveryOnly" ? -1 : 2, slaveStoreItem))
            })
          }
        })
      })
      this.invalidCount = this.getUniqWares(items).length
    },
    isChecked,
    soldOut,
    fen2Yuan,
    getNumber,
    getSmallNumber,
    // 切换全选
    async toggleSelectAll(checked) {
      if (!this.validSelectAll) return

      try {
        const items = this.validItems.map(item => ({
          ...item,
          count: item.showStockTip ? item.remainingStock : item.count,
          checked: checked ? 1 : 0
        }))
        const { data: res } = await modifyCartV2(this.getParams(items), 3)
        await this.setData(res)
      } catch (error) {
        console.log(error)
      }
    },
    // 删除选中的数据
    handleSelectionDelete() {
      if (!this.hasSelection) return

      this.openMsgBox()
    },
    openMsgBox() {
      this.$refs.messageBox.open()
    },
    closeMsgBox() {
      this.$refs.messageBox.close()
    },
    onCancel() {
      this.closeMsgBox()
    },
    // 确认删除(主品: mainProduct)
    async confirmDelete({ type = "mainProduct", promotionId, items = [], cb }) {
      console.log("isMainProduct===>", type, promotionId, items)
      const otherParams =
        type === "mainProduct"
          ? {}
          : {
              [`${type}ProId`]: promotionId
            }
      const curItems = type === "mainProduct" ? this.selectedItems : items
      const currentList = curItems.filter(val => val.preOrderShipmentType === this.shipmentType)
      currentList.forEach(item => {
        item.oldCount = _.cloneDeep(item.count)
        item.beforeCount = item.count // 记录之前的count
        item.count = 0 // 删除商品，count为0
      })
      try {
        const { data: res } = await modifyCartV2(this.getParams(curItems, otherParams), 3)
        if (type === "mainProduct") {
          this.closeMsgBox()
        }
        await this.setData(res)

        if (cb) {
          cb()
        }
      } catch (error) {
        console.log(error)
        curItems.forEach(item => {
          item.count = item.oldCount
        })
      }
    },
    getWareParams(item, otherParams, customParams) {
      const result = {
        sku: item.skuId,
        checked: item.checked,
        beforeCount: "beforeCount" in item ? item.beforeCount : item.count,
        count: item.count,
        ...otherParams
      }

      const customContentConfig = item.wareInfo?.preferenceOptions?.find(item => item.preferenceKey === customSkuKey)
      if (customContentConfig && item.chosedCustomisationRespList?.length > 0) {
        const chosedCustomisationRespList = item.chosedCustomisationRespList || []
        const customContentItem = chosedCustomisationRespList[0] || {}
        result.customisationList = [
          {
            count: item.count,
            checked: item.checked,
            remarkReq: customParams.customValue
              ? customParams.customValue === "defaultOption"
                ? "Default"
                : customParams.customText
              : customContentItem.chosedRemark,
            oldRemarkReq: customContentItem.chosedRemark,
            remarkType: customParams.customValue ? customParams.customValue : customContentItem.remarkType
          }
        ]
      }

      return result
    },
    getParams(items = [], otherParams = {}, customParams = {}) {
      // 根据门店分组
      const tempObj = {}
      items.forEach(item => {
        const storeId = item.storeId
        if (!(storeId in tempObj)) {
          tempObj[storeId] = {
            erpStoreId: storeId,
            wares: [this.getWareParams(item, otherParams, customParams)]
          }
        } else {
          tempObj[storeId].wares.push(this.getWareParams(item, otherParams, customParams))
        }
      })
      console.log("storeGroup===>", items, Object.values(tempObj))
      return {
        param: JSON.stringify({
          isCollage: false,
          sort: 0,
          simple: 1,
          addressId: this.defaultAddress.id,
          storeGroup: Object.values(tempObj)
        })
      }
    },
    // 取消勾选bestOffer时合并相同sku
    getBestOfferParamItems(items) {
      const tempObj = {}
      items.forEach(item => {
        const skuId = item.skuId
        if (!(skuId in tempObj)) {
          tempObj[skuId] = item
        } else {
          tempObj[skuId].count += item.count
        }
      })
      return Object.values(tempObj)
    },
    // 切换商品勾选
    async toggleWareSelect({ items = [], manualClick = true, bestOffer = false, promotionInfo = {} }) {
      if (this.soldOut(items[0])) return
      try {
        items.forEach(item => {
          item.oldChecked = _.cloneDeep(item.checked)
          item.checked = this.isChecked(item) ? 0 : 1
          item.oldCount = _.cloneDeep(item.count)
          if (manualClick && item.showStockTip) {
            item.beforeCount = item.count // 记录之前的count
            item.count = item.remainingStock
          }
        })
        const otherParams = bestOffer ? { proId: promotionInfo.promotionId } : {}
        const curItems = bestOffer ? this.getBestOfferParamItems(_.cloneDeep(items)) : items
        const { data: res } = await modifyCartV2(this.getParams(curItems, otherParams), 3)
        await this.setData(res)
      } catch (error) {
        console.log(error)
        items.forEach(item => {
          item.checked = item.oldChecked
          item.count = item.oldCount
        })
      }
    },

    // 异常切换商品勾选
    toggleWareSelectDisable(item) {
      this.goodsList.map(val => {
        if (val.uuid === item.uuid) {
          const goodsItem = val
          goodsItem.checked = !goodsItem.checked
          return goodsItem
        } else {
          return val
        }
      })
    },
    // 删除单个商品
    async handleWareDelete(item) {
      const oldCount = item.count
      try {
        item.beforeCount = item.count // 记录之前的count
        item.count = 0 // 删除商品，count为0
        const { data: res } = await modifyCartV2(this.getParams([item]), 3)
        await this.setData(res)
      } catch (error) {
        console.log(error)
        item.count = oldCount
      }
    },
    // 显示offline购物车提示信息
    showOfflineCartToastMessage(cartData = {}) {
      const toastMsg = cartData?.overToast || ""
      if (toastMsg) {
        showGlobalMessage({
          message: toastMsg,
          gap: 100,
          iconClass: "alert-info"
        })
      }
    },
    async handleNumChange(value, item) {
      if (value <= 0) {
        this.handleWareDelete(item)
        return
      }
      const oldChecked = item.checked
      item.checked = 1
      const oldCount = item.count
      item.beforeCount = item.count // 记录之前的count
      item.count = value
      console.log("item.count==>", item.count)

      try {
        const { data: res } = await modifyCartV2(this.getParams([item]), 3)
        await this.setData(res)
        console.log("handleNumChange", value, item.count)
        handleChangeCartNumber(value, oldCount, item)
        this.showOfflineCartToastMessage(res)
      } catch (error) {
        console.log(error)
        item.checked = oldChecked
        item.count = oldCount
      }
    },
    getAddressParams() {
      const { phone, areaCode, userName, name } = this.userInfo
      const { id, type, unitFloor = "", buildingEstate = "", label = "", lng, lat } = this.defaultAddress
      const encodeName = userName || name || ""
      const params = {
        consignId: id,
        phone: areaCode ? `${areaCode} ${phone}` : phone,
        userName: encodeURIComponent(encodeName),
        type,
        unitFloor: encodeURIComponent(unitFloor),
        buildingEstate: encodeURIComponent(buildingEstate),
        label: encodeURIComponent(label),
        longitude: lng, // '113.28028206682269'
        latitude: lat // '23.138333155834644'
      }

      return params
    },
    getMasterStoreId() {
      let masterStoreId = this.store.storeId

      if (!masterStoreId) {
        const firstSlaveStore = (this.slaveStoreList && this.slaveStoreList[0]) || {}
        masterStoreId = firstSlaveStore.storeInfo && firstSlaveStore.storeInfo.masterStoreId
      }

      return masterStoreId
    },
    openGiftMsgBox() {
      this.$refs.giftMessageBox && this.$refs.giftMessageBox.open()
    },
    closeGiftMsgBox() {
      this.$refs.giftMessageBox && this.$refs.giftMessageBox.close()
    },
    confirmCheckout() {
      this.trackBeginCheckout()
      try {
        const { id, consignee, address2, unitFloor, lat, lng, mobilPhone, userName, name, phone, areaCode } =
          this.defaultAddress
        const encodeName = userName || name || ""
        // return
        const otherParams = {
          masterStoreId: this.getMasterStoreId(),
          phone: this.shipmentType === 2 ? areaCode + " " + phone : mobilPhone,
          userName: this.shipmentType === 2 ? userName : consignee,
          addressId: id,
          shipmentType: this.shipmentType,
          offlinePaymentFlag: this.selectedOfflinePaymentFlag,
          consignee,
          addressName: address2,
          unitFloor,
          latitude: lat,
          longitude: lng,
          venderId: this.store.venderId
        }

        if (this.checkedCoupons && this.checkedCoupons.length) {
          Object.assign(otherParams, this.getCouponParams())
        } else {
          otherParams.couponCodeList = []
        }
        this.$navigation.push({
          path: "/checkout",
          query: {
            params: Base64.encode(JSON.stringify(Object.assign(this.getCouponBillParams(), otherParams)))
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleCheckout() {
      if (this.noAddressCheck() || !this.hasSelection || (this.isBillError && !this.isQuota)) return
      // selectedGiftNotFullFlag为1时标识赠品未选满，需要弹提示窗
      if (this.store.selectedGiftNotFullFlag == 1) {
        this.openGiftMsgBox()
      } else {
        this.confirmCheckout()
      }
    },
    // 配送结算逻辑
    handleCheckoutDelivery() {
      if (!this.hasSelection || (this.isBillError && !this.isQuota)) return
      // selectedGiftNotFullFlag为1时标识赠品未选满，需要弹提示窗
      if (this.store.selectedGiftNotFullFlag == 1) {
        this.openGiftMsgBox()
      } else {
        this.confirmCheckout()
      }
    },
    handleAddressChange() {
      this.deliveryMethodVisible = true
    },
    // 打开地址弹窗
    handleAddAddress(type) {
      if (type === "edit") {
        this.addressVisible = true
      } else {
        this.addAddressVisible = true
      }
    },
    // 保存选择的地址
    async handleSave(item) {
      this.addressVisible = false
      // // 更新选择的最新地址
      this.defaultAddress = item
      cartResetStoreInfo(item, true)
      // 初始化接口会请求优惠券
      await this.init(false)
    },
    // 创建地址
    async saveAddress() {
      await this.getMemberInfo(true)
      this.addAddressVisible = false
      // 初始化接口会请求优惠券
      await this.init(false)
    },
    // 关闭新增地址弹窗
    closeEdit() {
      this.addAddressVisible = false
    },

    handleClose() {
      this.addressVisible = false
    },
    handleUserInfoChange() {
      this.recipientVisible = true
    },
    onRecipientClose() {
      this.recipientVisible = false
    },
    onRecipientSave({ name, num, code }) {
      this.$set(this.userInfo, "userName", name)
      this.$set(this.userInfo, "phone", num)
      this.$set(this.userInfo, "areaCode", code)
    },
    handleCouponClick() {
      this.couponVisible = true
    },
    onCouponClose(isRefresh = false) {
      this.couponVisible = false
      if (isRefresh) {
        this.getCheckout(true)
      }
    },
    onCouponSave(values = []) {
      this.checkedCoupons = values
      this.getCheckout(true)
    },
    trackCartsList() {
      trackViewCart(this.data)
    },
    trackBeginCheckout() {
      trackBeginCheckout(this.data, this.checkedCouponCodes, this.totalPrice)
    },
    trackAddressChange(event) {
      const address = event.detail
      trackAddShippingInfo(this.selectedItems, this.checkedCouponCodes, this.totalPrice, address)
    },
    listenAddressChange() {
      document.addEventListener("addressChanged", this.trackAddressChange)
    },
    toggleDeliveryMethod(value) {
      if (this.deliveryMethodValue === value) return
      this.deliveryMethodValue = value
      this.deliveryMethodVisible = true
    },
    onDeliveryMethodClose() {
      this.deliveryMethodVisible = false
      this.deliveryMethodValue = getDeliveryMethod()
    },
    setDeliveryTabList(data) {
      const { storeList: tabStoreList } = data || {}
      const finaTabList = buildDeliveryTabList(tabStoreList, this.deliveryMethodList, this.expandOfflineMethodList)
      this.deliveryMethodList = finaTabList
      this.restoreSelectedDeliveryId(finaTabList)
    },
    restoreSelectedDeliveryId(deliveryMethodList) {
      const cachedId = sessionStorage.getItem("seveneleven_CART_SELECTED_DELIVERY_ID")
      const deliveryItem = deliveryMethodList.find(item => item.id === Number(cachedId))

      if (!deliveryItem) {
        sessionStorage.removeItem("seveneleven_CART_SELECTED_DELIVERY_ID")
        this.selectedDeliveryId = 1 // 默认选中第一个篮子
        this.shipmentType = 1
        this.selectedOfflinePaymentFlag = 0
        return
      }

      this.selectedDeliveryId = deliveryItem.id
      this.shipmentType = deliveryItem.shipmentType
      this.selectedOfflinePaymentFlag = deliveryItem.offlinePaymentFlag || 0
    },
    async deliveryChange(item) {
      this.selectedDeliveryId = item.id
      this.shipmentType = item.shipmentType
      this.selectedOfflinePaymentFlag = item.offlinePaymentFlag // 新增付款方式
      sessionStorage.setItem("seveneleven_CART_SELECTED_DELIVERY_ID", item.id)
      const goodsList = this.preOrderShipmentTypeChange(2, item.shipmentType, this.store)

      if (this.shipmentType === 1) {
        this.deliveryWares = goodsList
      } else {
        this.pickUpWares = goodsList
        // 切换到自体状态的时候，检查是否存在门店地址
        if (this.noAddressCheck()) {
          openNoAddressPop()
        }
      }
      // 切换配送的时候，考虑黑名单逻辑，需要请求购物车详情
      await this.init(false)
    },
    handleCloseSku(flag) {
      if (flag === "save") {
        this.init(false)
      }
      this.skuVisible = false
    },
    toSpuProductDetail(ware, customContentItem = {}) {
      this.skuVisible = true
      this.configs = {
        additional: {
          spuId: ware.spuId,
          sku: ware.skuId,
          count: ware.count,
          beforeCount: ware.beforeCount,
          savedCustomType: customContentItem.remarkType,
          savedCustomText: customContentItem.chosedRemark
        },
        skuId: ware.skuId
      }
    },
    openCustomContentDlg(ware, customContentConfig, customContentItem = {}) {
      this.customSkuVisible = true
      this.configs = {
        ware,
        additional: {
          sku: ware.skuId,
          savedCustomType: customContentItem.remarkType,
          savedCustomText: customContentItem.chosedRemark
        }
      }
      this.customContentConfig = customContentConfig
    },
    async updateCustomContent({ customValue, customText }) {
      try {
        const { data: res } = await modifyCartV2(
          this.getParams([this.configs.ware], {}, { customValue, customText }),
          3
        )
        this.$refs?.productCustomSku?.handleClose()

        await this.setData(res)
      } catch (error) {}
    }
  }
}
